import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tagsite: null,
  loading: false,
  error: null,
  articles: [],
  articlesLoading: false,
  articlesError: null,
  hasMoreArticles: true,
  currentPage: 1,
  beautyShorts: [],
  beautyShortsLoading: false,
  beautyShortsError: null,
  hasMoreBeautyShorts: true,
  beautyShortsCurrentPage: 1,
  contentCounts: {
    total: 0,
    article: 0,
    quiz: 0,
    poll: 0,
  },
  contentCountsLoading: false,
  contentCountsError: null,
};

const tagsiteSlice = createSlice({
  name: 'tagsite',
  initialState,
  reducers: {
    getTagsiteStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getTagsiteSuccess: (state, action) => {
      state.tagsite = action.payload;
      state.loading = false;
      state.error = null;
    },
    getTagsiteFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearTagsite: (state) => {
      state.tagsite = null;
      state.loading = false;
      state.error = null;
      state.articles = [];
      state.articlesLoading = false;
      state.articlesError = null;
      state.hasMoreArticles = true;
      state.currentPage = 1;
      state.beautyShorts = [];
      state.beautyShortsLoading = false;
      state.beautyShortsError = null;
      state.hasMoreBeautyShorts = true;
      state.beautyShortsCurrentPage = 1;
    },
    getTagsiteArticlesStart: (state) => {
      state.articlesLoading = true;
      state.articlesError = null;
    },
    getTagsiteArticlesSuccess: (state, action) => {
      if (action.payload.page === 1) {
        state.articles = action.payload.articles;
      } else {
        state.articles = [...state.articles, ...action.payload.articles];
      }
      state.currentPage = action.payload.page;
      state.hasMoreArticles = action.payload.hasMore;
      state.articlesLoading = false;
      state.articlesError = null;
    },
    getTagsiteArticlesFailure: (state, action) => {
      state.articlesLoading = false;
      state.articlesError = action.payload;
    },
    getTagsiteBeautyShortsStart: (state) => {
      state.beautyShortsLoading = true;
      state.beautyShortsError = null;
    },
    getTagsiteBeautyShortsSuccess: (state, action) => {
      if (action.payload.page === 1) {
        state.beautyShorts = action.payload.beautyShorts;
      } else {
        state.beautyShorts = [
          ...state.beautyShorts,
          ...action.payload.beautyShorts,
        ];
      }
      state.beautyShortsCurrentPage = action.payload.page;
      state.hasMoreBeautyShorts = action.payload.hasMore;
      state.beautyShortsLoading = false;
      state.beautyShortsError = null;
    },
    getTagsiteBeautyShortsFailure: (state, action) => {
      state.beautyShortsLoading = false;
      state.beautyShortsError = action.payload;
    },
    getContentCountsStart: (state) => {
      state.contentCountsLoading = true;
      state.contentCountsError = null;
    },
    getContentCountsSuccess: (state, action) => {
      state.contentCountsLoading = false;
      state.contentCounts = action.payload;
    },
    getContentCountsFailure: (state, action) => {
      state.contentCountsLoading = false;
      state.contentCountsError = action.payload;
    },
    resetPostsList: (state) => {
      state.articles = [];
      state.articlesLoading = true;
      state.currentPage = 1;
      state.hasMoreArticles = true;
    },
    resetBeautyShortsList: (state) => {
      state.beautyShorts = [];
      state.beautyShortsLoading = true;
      state.beautyShortsCurrentPage = 1;
      state.hasMoreBeautyShorts = true;
    },
  },
});

export const {
  getTagsiteStart,
  getTagsiteSuccess,
  getTagsiteFailure,
  clearTagsite,
  getTagsiteArticlesStart,
  getTagsiteArticlesSuccess,
  getTagsiteArticlesFailure,
  getTagsiteBeautyShortsStart,
  getTagsiteBeautyShortsSuccess,
  getTagsiteBeautyShortsFailure,
  getContentCountsStart,
  getContentCountsSuccess,
  getContentCountsFailure,
  resetPostsList,
  resetBeautyShortsList,
} = tagsiteSlice.actions;

export const selectTagsite = (state) => state.tagsite.tagsite;
export const selectTagsiteLoading = (state) => state.tagsite.loading;
export const selectTagsiteError = (state) => state.tagsite.error;
export const selectTagsiteArticles = (state) => state.tagsite.articles;
export const selectTagsiteArticlesLoading = (state) =>
  state.tagsite.articlesLoading;
export const selectTagsiteArticlesError = (state) =>
  state.tagsite.articlesError;
export const selectHasMoreArticles = (state) => state.tagsite.hasMoreArticles;
export const selectCurrentPage = (state) => state.tagsite.currentPage;
export const selectTagsiteBeautyShorts = (state) => state.tagsite.beautyShorts;
export const selectTagsiteBeautyShortsLoading = (state) =>
  state.tagsite.beautyShortsLoading;
export const selectTagsiteBeautyShortsError = (state) =>
  state.tagsite.beautyShortsError;
export const selectHasMoreBeautyShorts = (state) =>
  state.tagsite.hasMoreBeautyShorts;
export const selectBeautyShortsCurrentPage = (state) =>
  state.tagsite.beautyShortsCurrentPage;
export const selectContentCounts = (state) => state.tagsite.contentCounts;
export const selectContentCountsLoading = (state) =>
  state.tagsite.contentCountsLoading;

export default tagsiteSlice.reducer;
